import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="update-delivery-group-id"
export default class extends Controller {
  connect() {
    console.log("updateDeliveryGroupIdController connected");
  }

  async call(event) {
    if (!confirm("本当にグループ番号を変更しますか？")) return;

    const tr = event.target.closest("tr");
    const id = tr.dataset.deliveryId;
    const group_number = event.target.value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(
      `/deliveries/${id}/update_delivery_group_from_group_number`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ group_number })
      }
    );

    if (response.ok) {
      window.location.reload();
    } else {
      console.error("Failed to update delivery group number");
    }
  }
}
